/**
 * RF-11.3 · Consulta de la bitácora de auditoría.
 *
 * Solo lectura: la bitácora se escribe desde el backend y no se edita ni se
 * borra, porque un registro modificable no sirve como evidencia.
 *
 * Store Pinia: estado compartido del módulo y orquestación de sus servicios.
 * Las vistas no llaman a `http` ni a los servicios directamente; pasan por aquí.
 * Los servicios no lanzan, así que las acciones interpretan valores neutros
 * (`[]`, `null`, `false`) como fallo.
 */

import { defineStore } from 'pinia'
import type AuditoriaEvaluacion from '@/interfaces/AuditoriaEvaluacion'
import {
  getAuditoriaEvaluacionService,
  getAuditoriaVersionService,
  exportarAuditoriaService
} from '@/services/AuditoriaService'

/** Store `auditoria`. Ver la cabecera del archivo para el contrato del módulo. */
export const useGestionAuditoria = defineStore('auditoria', {
  state: () => ({
    registros: [] as AuditoriaEvaluacion[]
  }),

  actions: {
    async cargarPorEvaluacion(idEvaluacion: number): Promise<void> {
      this.registros = await getAuditoriaEvaluacionService(idEvaluacion)
    },

    async cargarPorVersion(idVersion: number): Promise<void> {
      this.registros = await getAuditoriaVersionService(idVersion)
    },

    async exportar(idVersion: number, formato: 'json' | 'csv'): Promise<void> {
      const blob = await exportarAuditoriaService(idVersion, formato)
      if (!blob) return
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `auditoria_version_${idVersion}.${formato}`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }
  }
})
